import { View, StyleSheet } from "react-native";
import { colors } from "@/lib/theme";

export default function StumpsIcon({ size = 28 }: { size?: number }) {
  const scale = size / 28;
  const stumpW = Math.round(2.2 * scale);
  const stumpH = Math.round(14 * scale);
  const bailW = Math.round(6 * scale);
  const bailH = Math.round(2.2 * scale);
  const gap = Math.round(4.2 * scale);
  const borderR = Math.round(size * 0.28);

  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: borderR,
        backgroundColor: colors.brand,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Bails */}
      <View style={{ flexDirection: "row", gap: gap * 0.5, marginBottom: -1 }}>
        <View style={{ width: bailW, height: bailH, borderRadius: 1, backgroundColor: "rgba(255,255,255,0.85)" }} />
        <View style={{ width: bailW, height: bailH, borderRadius: 1, backgroundColor: "rgba(255,255,255,0.85)" }} />
      </View>
      {/* Stumps */}
      <View style={{ flexDirection: "row", gap: gap * 0.6 }}>
        <View style={{ width: stumpW, height: stumpH, borderRadius: 1, backgroundColor: "#fff" }} />
        <View style={{ width: stumpW, height: stumpH, borderRadius: 1, backgroundColor: "#fff" }} />
        <View style={{ width: stumpW, height: stumpH, borderRadius: 1, backgroundColor: "#fff" }} />
      </View>
    </View>
  );
}
